import { saveAs } from 'file-saver';

export { saveAs };
